import React from 'react';
import { Container } from '@gjensidige/core-grid';
import { Text, Title } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import pickingApples from '../resources/images/picking_apples.svg';
import styles from './Footer.module.scss';

const Footer = () => {
  const { getText } = useCmsContext();

  return (
    <div className={styles.footer}>
      <Container className={styles.container}>
        <div className={styles.content}>
          <Title tag="h1" size="h3">
            {getText('housing.check.footer.title')}
          </Title>
          <Text size="lead">{getText('housing.check.footer.text1')}</Text>
          <Text size="lead">{getText('housing.check.footer.text2')}</Text>
        </div>
        <img
          className={styles.image}
          src={pickingApples}
          alt="picking-apples"
        />
      </Container>
    </div>
  );
};

export default Footer;
